<script setup>
import 'slick-carousel/slick/slick.js';
import {onMounted, useTemplateRef} from 'vue';

const {options} = defineProps({
    options: Object,
});

const container = useTemplateRef('container');

onMounted(() => {
    $(container.value).slick(options);
});
</script>

<template>
    <div ref="container">
        <slot></slot>
    </div>
</template>
